<template>
  <teleport to="body">
    <div class="modal fade" id="miw-components-modal" tabindex="-1" role="dialog"
         aria-labelledby="miw-components-label"
         aria-hidden="true">
      <div class="modal-dialog modal-xl">
        <div class="modal-content" v-if="modalStatus">
          <div class="modal-header">
            <h5 class="modal-title" id="miw-components-label">کامپوننت‌ها</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="d-block">
              <select class="custom-select my-3" v-model="selectedComponentGroup">
                <option value="null">choose component group</option>
                <option v-for="component in Object.keys(components)" :key="component">{{ component }}</option>
              </select>

              <div v-if="selectedComponentGroup != null">
                <component-viewer-item
                  v-for="(component, file) in components[selectedComponentGroup]"
                  :key="file"
                  :component-file="file"
                  :component-object="component"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
import * as miwComponents from '@moeinmdn/miw-alpha-components/src/package/IndexComponentMap'
import {mapActions, mapGetters} from "vuex";
import ComponentViewerItem from "@/components/ComponentViewer/ComponentViewerItem";
import $ from 'jquery'
import store from '@/store'
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "ComponentViewer",
  components: {ComponentViewerItem},
  data() {
    return {
      miwComponents,
      components: {},
      selectedComponentGroup: null
    }
  },
  computed: {
    ...mapGetters({
      modalStatus: 'Site/getComponentModalStatus'
    })
  },
  methods: {
    ...mapActions({
      setSelectedComponent: 'Site/setSelectedComponent'
    }),
    openPicker() {
      this.$store.dispatch('Site/setComponentModalStatus', true)
      this.$nextTick(() => {
        $('#miw-components-modal').modal('show')
      })
    },
    openModal(clearSelection = true) {
      if (clearSelection) {
        this.setSelectedComponent({id: '', slot: 'default'})
      }
      this.openPicker()
      toast('در حال نمایش component ها', 'در حال نمایش component ها')
    },
    componentFolder(componentPath) {
      let folderPath = componentPath.split('/');
      folderPath.pop()
      return folderPath.join('/')
    },
  },
  mounted() {
    Object.keys(this.miwComponents).forEach(component => {
      const componentPath = this.miwComponents[component].path.replace('./', '')
      let componentFolder = this.componentFolder(componentPath);
      if (this.components[componentFolder] == undefined) {
        this.components[componentFolder] = {}
      }
      this.components[componentFolder][component] = this.miwComponents[component]
    })

    window.addEventListener('ps-open-components-modal', this.openPicker)
    $('#miw-components-modal').on('hidden.bs.modal', () => {
      store.dispatch('Site/setComponentModalStatus', false)
    })
  },
  beforeUnmount() {
    window.removeEventListener('ps-open-components-modal', this.openPicker)
    $('#miw-components-modal').off('hidden.bs.modal')
  }
}
</script>

<style scoped>

</style>